import * as React from 'react';
import { Link } from 'react-router-dom';

import { getImageFromProductByVariant } from '../../helpers/getImageFromProductByVariant';
import { findPrice } from '../../helpers/prices';
import { SizeBox } from '../modules';
import { buildProductLink } from '../../pages/ProductDetail/ProductDetailPage';
import { CurrencyFormatter as Currency } from '../../utils/utils';
import Image from '../../components/Image';

interface IProductBoxNewsProps {
  product: GQL.IProduct;
  // variant?: GQL.IProductVariant;
  // quantity?: number;
  size?: string;
  sizes?: Array<string>;
  language?: string;
  category?: GQL.ICategory;
  onChange?: (newVal: number) => void;
  onRemove?: () => void;
  onToggleFavorite?: (variantId: string) => void;

  image?: GQL.IImage | null;
  isFavorite?: boolean;
}

interface IProductBoxNewsState {
}

class ProductBoxNews extends React.PureComponent<IProductBoxNewsProps, IProductBoxNewsState> {

  constructor(props: IProductBoxNewsProps) {
    super(props);
    this.state = {};
  }

  public setFormState(fields: any) {
    this.setState({ fields });
  }

  public handleSend() {
    //
  }

  public render() {
    const { product, sizes, category } = this.props;

    const { variants } = product;

    const price = findPrice(product.prices, false, null, product);

    const variant = (variants && variants.length > 0 ? variants[0] : null);

    if (!variant) {
      return null;
    }

    const language = this.props.language || 'en';
    const image = this.props.image || getImageFromProductByVariant(product, variant as GQL.IProductVariant);

    return (
      <div
        className={'productBox productBox--catalog'}
      >
        <Link to={buildProductLink(product, category, variant as GQL.IProductVariant, language) || ''} className="block">
          <Image image={image} className="productBox__img" alt={product.name[language]}/>
        </Link>
        <div>
          <Link to={buildProductLink(product, category, variant as GQL.IProductVariant, language) || ''} className="productBox__title block">
            {product.name[ language ]}
          </Link>
          <div className="productBox__bottom">
            <div className="productBox__price">
              <Currency price={price || 0} />
            </div>
            <div className="productBox__sizes">
              {sizes &&
                sizes.map((item, i) => {
                  return <SizeBox key={i} size={item}/>;
                })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  private toggleFavorite(variantId: string) {
    if (this.props.onToggleFavorite) {
      this.props.onToggleFavorite(variantId);
    }
  }
}

export default ProductBoxNews;



// WEBPACK FOOTER //
// ./src/modules/ProductBoxNews/ProductBoxNews.tsx